module.exports = __webpack_public_path__ + "static/media/audio-20-tt.d3d21af9.mp3";